<template>
    <div class="home-container px">
        <div class="wrap">
            <section id="use">
                <h2 class="h2-4">
                    <span>アタッチメント・ラブ</span>
                    <br>
                    <span>は他のクラブではないサービスを提供しています</span>
                </h2>
                <div class="use">
                    <span class="num">1</span>
                    <div class="box">
                        <h3>全国47都道府県どこでもオンラインマッチングが可能です</h3>
                        <div class="note">
                            <p>日本にいらっしゃる限り、当クラブはオンラインでマッチングサービスを提供できます。</p>
                        </div>
                        <p class="mb30">
                            <img src="/img/highlevel/use01.jpg" alt="全国47都道府県どこでも面談可能">
                        </p>
                    </div>
                </div>
                <div class="use">
                    <span class="num">2</span>
                    <div class="box">
                        <h3>登録女性の無加工写真</h3>
                        <div class="note">
                            <p>なんといっても写真については、どこのクラブにも引けを取らないほどのクオリティーの高さを自負しております。</p>
                            <p>なによりも、掲載している女性の写真には一切の加工は施しておりません。</p>
                        </div>
                        <p class="mb30">
                            <img src="/img/highlevel/use02.jpg" alt="登録女性の無加工写真">
                        </p>
                        <div class="note">
                            <p>出会いアプリだと、簡単に写真加工を行って可愛く見せることが出来ます。</p>
                            <p>結局お会いした際に「別人だ」とショックを受けてしまうことは目に見える結果です。</p>
                            <p>近くの愛のクラブでは、そういった会った時のズレをなくすためにも、クオリティの高い写真であり、嘘の一切使わない無加工な写真を掲載しております。
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="anxiety">
            <h2 class="h2-5">近くの愛に入る
                <br>
                <span>こんな<em>不安</em>を感じて
                    <br>いませんか？</span>
            </h2>
            <ul class="check-list">
                <li>会う女性はどうせ
                    <span>サクラじゃないか？</span>
                </li>
                <li>出会うまでのやり取りと
                    <span>時間と手間がかかる</span>
                </li>
                <li>美人局がくるのか心配で
                    <span>怖い</span>
                </li>
                <li>出会った後に
                    <span>トラブルに巻き込まれる</span>
                </li>
            </ul>
            <p class="center">残念ながら出会いアプリでは、中にはトラブルに
                <br class="sp">巻き込まれてしまうという恐ろしいケースも…
            </p>
        </section>
        <div class="wrap2">
            <p class="title1">
                <span class="red">ちかくのあい</span>なら、
                <br>
                <span>心配は1ミリもいりません!</span>
            </p>
            <div id="initiative" class="safety">
                <dl>
                    <div>
                        <dt>男性会員様の為に
                            <br>安心安全にご利用いただくための
                            <br>
                            <span>
                                <em>5</em>つの取り組み</span>
                        </dt>
                        <dd>ちかくのあいのセキュリティはマッチング業界で最先端のシステムを導入しております。
                            <br>男性会員様の皆様にとって、安心であり安全な形で多くの方にお会いしていただきたいということで、様々な取り組みを行っております。
                        </dd>
                    </div>
                </dl>
            </div>
            <ol class="worth">
                <li>
                    <p class="photo">
                        <img src="/img/highlevel/worth01.png" alt="5つの取り組">
                    </p>
                    <div>
                        <h3>●入会する全女性に対しては、対面面接を必須とし実施</h3>
                        <p>◎不適切な会員・精神的にも危ない方、男性に対して横暴な態度を取りそうな方、連絡がスムーズに取れないような方には入会をお断りしています。</p>
                    </div>
                </li>
                <li>
                    <p class="photo">
                        <img src="/img/highlevel/worth02.png" alt="5つの取り組">
                    </p>
                    <div>
                        <h3>●全女性会員は、公的身分証提出の義務</h3>
                        <p>◎面談をされる際に、公的機関が発行したご本人様の身分証明書を提出していただいてのご入会を義務化しています。</p>
                    </div>
                </li>
                <li>
                    <p class="photo">
                        <img src="/img/highlevel/worth03.png" alt="5つの取り組">
                    </p>
                    <div>
                        <h3>●登録は匿名倶楽部ネームでOK</h3>
                        <p>◎ご登録いただく電話番号・メールアドレスなどの個人情報は一切公開されません。</p>
                    </div>
                </li>
                <li>
                    <p class="photo">
                        <img src="/img/highlevel/worth04.png" alt="5つの取り組">
                    </p>
                    <div>
                        <h3>●データ通信のセキュリティは最高峰レベル</h3>
                        <p>◎サイト内のデータ通信すべてにおいて、最高峰レベルのセキュリティ「EVSSL」を採用しています。</p>
                    </div>
                </li>
                <li>
                    <p class="photo">
                        <img src="/img/highlevel/worth05.png" alt="5つの取り組">
                    </p>
                    <div>
                        <h3>●必要な届出提出受理済みです</h3>
                        <p>◎紹介事業ならびにデートクラブ条例の届け出を東京都公安委員会に行い受理済みです。万が一のトラブルにも迅速に対応できます。</p>
                    </div>
                </li>
            </ol>
            <p class="banner">
                <img src="/img/highlevel/gokan_sp.jpg" alt="5冠達成" class="js-image-switch">
            </p>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { Toast } from 'vant'
import Footer from '@/components/footer';
export default {
    components: {
    Footer
  },
    data() {
        return {
            active: 0,
            isLoading: false,
            count: 0,
            loading: false,
            finished: false,
            refreshing: false,
            videolitem: [],
            videolist: [],
            number: 0,
            page: 0,
            videoSwiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                slidesPerGroup: 1
            }
        }
    },
    methods: {
        getVideoClass() {
            this.$http({
                method: 'get',
                url: 'video_class'
            }).then((res) => {
                this.videolitem = res.data
            })
        },
        toPlayVideo(id) {
            if (!localStorage.getItem('token')) {
                this.$router.push({ path: '/Login' })
            } else {
                this.$router.push({ path: '/PlayVideo?id=' + id })
            }
        },
        itemChange() {
            this.active = this.$refs.swiper.swiper.activeIndex
            this.OnChange()
        },
        getVideoList() {
            this.$http({
                method: 'get',
                data: { id: this.active, page: this.page },
                url: 'video_list'
            }).then((res) => {
                this.videolist = this.videolist.concat(res.data.data)
                this.count = res.data.count
                this.page++
            })
        },
        onLoad() {
            // this.getVideoList()
            // let timer = setTimeout(() => {
            //     if (this.refreshing) {
            //         this.videolist = []
            //         this.refreshing = false
            //     }
            //     this.loading = false
            //     if (this.videolist.length === this.count) {
            //         this.finished = true
            //     }
            //     this.finished && clearTimeout(timer) //清除计时器
            // }, 500)
        },
        OnChange() {
            this.videolist = []
            this.number = 0
            this.page = 0
            this.count = 0
            this.getVideoList() //获取视频列表
        },
        onRefresh() {
            setTimeout(() => {
                this.finished = false
                this.loading = true
                this.onLoad()
                this.isLoading = false
                Toast(this.$t('home.refresh_successful'))
            }, 500)
        }
    },
    created() {
        // this.getVideoClass() //获取视频类目
        // this.OnChange()
    }
}
</script>

<style lang='less' scoped>
.page {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    background-color: #f2f2f5;
}

.home-container {

    font-family: YuGothic, 'Yu Gothic', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif;
    font-size: 1.5rem;
    line-height: 1.6;
    color: #111;
    background: #f3f3f3;
    padding-bottom: 40px;
    //   font-size: 62.5%;
}

.px {
    font-size: 62.5%;
}

p {
    font-family: YuGothic, 'Yu Gothic', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif !important;
}

.wrap {
    margin: 0 15px 80px;
}

.box {
    width: 95%;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 20px;
}

h2 {
    text-align: center;
    font-family: 'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', YuGothic, 'Yu Gothic', sans-serif;
    font-weight: bold;
    font-size: 2.2em;
    margin: 0 0 64px;
}

h2.h2-4 {
    font-size: 2em;
    line-height: 1.3;
    border-bottom: 9.6px solid #d0b67d;
    padding: 10px 0 20px;
}
h2.h2-4 span {
    font-size: 1.875rem;
    color: #d0b67d;
}

.use {
    position: relative;
    padding: 40px 20px 20px;
    border: 1px solid #111;
    background: #ececec;
    margin: 0 0 30px;
}

.use span.num {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    color: #fff;
    font-size: 3em;
    padding: 0 0 0 15px;
}

.use::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-bottom: 7em solid transparent;
    border-left: 7em solid #111;
}



.use h3 {
    font-weight: bold;
    font-size: 2.2em;
    text-align: center;
    margin: 0 0px 30px;
}

.note {
    background-image: linear-gradient(#242424 1px, transparent 1px);
    background-size: auto 51px;
    line-height: 51px;
    border-bottom: 1px solid #242424;
    overflow: hidden;
    margin: 0 0 30px;
    text-align: left;
}

.note p {
    margin: 0;
    font-size: .9375rem;
}

.mb30 {
    margin: 0 0 30px 0;

    img {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
    }
}

.anxiety {
    background: #111;
    color: #fff;
    padding: 30px;
    position: relative;
}

.anxiety::before {
    content: "ですが";
    color: #111;
    font-size: 1.875rem;
    font-weight: bold;
    position: absolute;
    bottom: -8%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 1;
    box-sizing: border-box;
}

.anxiety::after {
    content: "";
    width: 0;
    height: 0;
    border: solid 192px transparent;
    border-top: solid 160px #e6d8b3;
    position: absolute;
    bottom: -34%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    box-sizing: border-box;
}

.anxiety .center {
    font-weight: bold;
    font-size: 6.3vw;
    text-align: center
}

h2.h2-5 {
    background: url(/img/highlevel/fukidashi02.png) no-repeat 40% top;
    background-size: 336px;
    padding: 152px 0 0;
    font-size: 8vw;
    line-height: 1.4;
}

h2.h2-5 span em {
    font-size: 2.5rem;
    margin-left: 0;
}

.check-list {
    background: #242424;
    border: 15px solid #e6d8b3;
    border-radius: 25px;
    padding: 40px;
    margin: 0 auto 60px;
    max-width: 600px;
}

.check-list li {
    position: relative;
    padding: 0 0 0 40px;
    margin: 0 0 25px;
    font-weight: bold;
    font-size: 1.125rem;
}

.check-list li:before,
.check-list li:after {
    content: "";
    display: block;
    position: absolute;
    scale: 1.6;
}

.check-list li:before {
    width: 22px;
    height: 22px;
    border-radius: 14px;
    background: #aa0000;
    top: 7px;
    left: 0;
    scale: 1.6;
}

.check-list li:after {
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    width: 8px;
    height: 3px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 15px;
    left: 6px;
    scale: 1.6;
}

.check-list li span {
    color: #aa0000;
}

.wrap2 {
    margin: 0 0 80px;

    p.title1 {
        text-align: center;
        padding: 120px 15px 90px;
        font-weight: bold;
        font-size: 1.56rem;
        font-family: 'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', YuGothic, 'Yu Gothic', sans-serif;
        line-height: 1.3;
    }

    p.title1 span {
        font-size: 2.6rem;
    }

    span.red {
        color: #aa0000;
    }

    .safety {
        background: url(/img/highlevel/men.jpg) no-repeat bottom center;
        background-size: contain;
        padding: 0 0 60vh;
    }

    .safety dl {
        background: #d0b67d;
        color: #fff;
        padding: 10px;
        margin: 0 0 10px;
    }

    .safety dl div {
        padding: 10px;
        border: 1px solid #fff;
    }

    .safety dt {
        border-bottom: 8px solid #fff;
        margin: 32px 0px 48px;
        padding: 0 0px 17px;
        font-size: 1.375rem;
        font-weight: bold;
    }

    .safety dt span {
        display: block;
        text-align: center;
        font-size: 1.875rem;
        line-height: 1.3;
    }

    .safety dt span em {
        font-style: normal;
        font-size: 6.25rem;
        font-family: 'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', YuGothic, 'Yu Gothic', sans-serif;
    }

    .safety dd {
        margin: 0 0 32px;
        line-height: 2;
        font-size: 0.9375rem;
    }

    ol.worth {
        margin: 0 0 60px;
    }

    ol.worth li:nth-child(odd) {
        background: #e9e9e9;
    }

    ol.worth li {
        padding: 30px 20px;
    }

    ol.worth li .photo {
        margin: 0 auto 20px;
        width: 192px;
        img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
}
    }

    ol.worth li h3 {
        font-weight: bold;
        font-size: 1.375rem;
        padding: 0 0 10px;
        margin: 0 0 20px;
        border-bottom: 1px solid #686868;
    }

    ol.worth li p {
        margin: 0;
        font-size: 0.9375rem;
    }

    .banner {
        text-align: center;
        max-width: 800px;
        margin: 0 auto 50px;
        padding: 0 20px;
        box-sizing: border-box;

        img {
            max-width: 100%;
            height: auto;
            vertical-align: middle;
        }
    }
}
</style>
